import { render, staticRenderFns } from "./read-email-settings.vue?vue&type=template&id=3a8aa856&scoped=true"
import script from "./read-email-settings.vue?vue&type=script&lang=js"
export * from "./read-email-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8aa856",
  null
  
)

export default component.exports